import React, { useState, useEffect } from 'react'
import SelectNumber from '../../ui/SelectNumber'
import { Typography } from '@mui/material'

export default function ScreenerFiltersChange({value, rule, label, setValue, fieldName}) {
    const [change, setChange] = useState(value)

    useEffect(() => {setValue({name:fieldName, value:change});return () => {}},[change]) // eslint-disable-line

    useEffect(() => {rule !== 'between' && setChange({change: change.change});return () => {}},[rule]) // eslint-disable-line

    const updateChange = (value) => setChange(state => ({...state, [value.name] : value.value}))
    
    return (
        <>
            <SelectNumber label={label} value={change.change} setValue={updateChange} fieldName='change'/>
            { rule === 'between' && 
                <>
                    <span>
                        <Typography>And</Typography>
                    </span>
                    <SelectNumber label={label} value={change.change1 ?? 10} setValue={updateChange} fieldName='change1'/>
                </>
            }
        </>
    )
}

